module.exports = __webpack_public_path__ + "media/icons/facebook@2x-ddb2b3c6.png";